import { render, staticRenderFns } from "./ButtonProduct.vue?vue&type=template&id=43866d24&"
import script from "./ButtonProduct.vue?vue&type=script&lang=js&"
export * from "./ButtonProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports